import React, { useEffect } from "react";
import { imgWelcomeMinisoLover } from "../../assets/ImgLinks";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";
import useUser from "../../hooks/useUser";
import { pinguinoAzulRegistro } from "../../assets/ImgLinks";

/**
 * 
 * 
 * <!-- Meta Pixel Code y Lead-->
    <script>
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );
      fbq("init", "2430285977237161");
      fbq("track", "PageView");
      fbq("track", "Lead");
    </script>
    <noscript
      ><img
        height="1"
        width="1"
        style="display: none"
        src="https://www.facebook.com/tr?id=2430285977237161&ev=PageView&noscript=1"
    /></noscript>
    <!-- End Meta Pixel Code -->
 * 
 * 
 * 
 * 
 * 
 * 
      const pixelFace = (f, b, e, v, n, t, s)=> {
        if (f.fbq) return;

        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };

        if (!f._fbq) f._fbq = n;

        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      }
      
      
      pixelFace(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );

      window.fbq("init", "2430285977237161");
      window.fbq("track", "PageView");
      window.fbq("track", "Lead");
    
    
 * 
 * 
 */

const WelcomeMinisoLover = ({isExpress}) => {
  const [dataUser, setDataUser, initialDataUser] = useUser();

  const miPerfilUrl = "https:/www.miniso.com.mx/account#/plan-lealtad";

  useEffect(() => {

    //<!-- Event snippet for Registros Minisolove conversion page -->

  //gtag('event', 'conversion', {'send_to': 'AW-706013356/8_RXCPbmrpAZEKzR09AC'});
  window.dataLayer = window.dataLayer || [];
  function gtag(){
    window.dataLayer.push(arguments);
  }
  gtag('event', 'conversion', {'send_to': 'AW-706013356/8_RXCPbmrpAZEKzR09AC'});




    window.fbq("init", "2430285977237161");
    window.fbq("track", "PageView");
    window.fbq("track", "Lead");

    const pixelFace = (f, b, e, v, n, t, s) => {
      if (f.fbq) return;

      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };

      if (!f._fbq) f._fbq = n;

      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    };

    pixelFace(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );

    return;
  }, []);

  const handleReload = () => {
    setDataUser({
      ...initialDataUser,
      pageReload: false,
    });
  };

  const handleRedirect = () => {
      //window.open('https:/www.miniso.com.mx/account#/plan-lealtad', '_blank');
      window.location.href = 'https://www.miniso.com.mx/account#/plan-lealtad';
  }

  return (
    <div className="pt-3 pb-3 w-100">
      <div className="d-flex align-items-center justify-content-center">
        <img
          style={{ width: "20vw" }}
          className="rounded"
          src={pinguinoAzulRegistro}
          alt="pinguinoAzulRegistro"
        />
        <h3 style={{ color: "#3ABDBC" }} className="fs-1 ms-3">
          REGISTRO
        </h3>
      </div>
      <h6 style={{ color: "#915DCF" }} className="mt-2 fs-6 text-center">
        ¡Listo! Ya debes haber recibido tu cupón de descuento en tu bandeja de
        correo y ya puedes empezar a acumular puntos.{" "}
      </h6>
      <h6 className="text-center text-muted fs-6 small">Recuerda buscar en Spam tu Cupón si no lo ves en tu bandeja de entrada.</h6>
      
        <div
          style={{ width: "100vw" }}
          className="d-flex justify-content-center"
        >
          <button
            style={{
              border: "none",
              backgroundColor: "#ff000070",
              color: "#000",
              textDecoration: "none",
            }}
            onClick={handleRedirect}
            className="rojoHover rounded w-50 mt-3 fw-bold text-center ms-auto me-auto"
          >
            {" "}
            Ir a mi perfil
            </button>
        </div>
      
      <h6 style={{ color: "#915DCF" }} className="mt-2 fs-6 text-center">
        Para más diversión y premios descarga la app Miniso México.
      </h6>
      <Container className="w-100 d-flex justify-content-end mb-3">
        <Link
          to={isExpress?'/registro_express':'/'}
          onClick={handleReload}
          className="btn btn-secondary fs-5 mt-3"
        >
          {<AiOutlineHome /> || "Home"}
        </Link>
      </Container>
      <img
        className="w-100"
        src={imgWelcomeMinisoLover}
        alt="imgWelcomeMinisoLover"
      />
    </div>
  );
};

export default WelcomeMinisoLover;
